import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cart") || "[]"); } catch { return []; }
  });
  const [eventDate, setEventDate] = useState(() => localStorage.getItem("event_date") || "");

  useEffect(() => { localStorage.setItem("cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem("event_date", eventDate || ""); }, [eventDate]);

  const add = (item, quantity) => {
    setItems((prev) => {
      const existing = prev.find((l) => l.item_id === item.id);
      if (existing) {
        return prev.map((l) => l.item_id === item.id
          ? { ...l, quantity: Math.min(l.quantity + quantity, item.available_quantity) } : l);
      }
      return [...prev, { item_id: item.id, name: item.name, price: item.price,
        unit: item.unit, image: item.image, quantity, max: item.available_quantity }];
    });
  };
  const setQty = (id, q) => setItems((prev) => prev.map((l) => l.item_id === id
    ? { ...l, quantity: Math.max(1, Math.min(q, l.max)) } : l));
  const remove = (id) => setItems((prev) => prev.filter((l) => l.item_id !== id));
  const clear = () => setItems([]);
  const count = items.reduce((s, l) => s + l.quantity, 0);
  const subtotal = items.reduce((s, l) => s + l.price * l.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal, eventDate, setEventDate }}>
      {children}
    </CartContext.Provider>
  );
}
